switch(process.env.NODE_ENV) {
  case "production":
    module.exports = {
      uri: 'http://api.liepaja.lv:3011/graphql',
      google: {
        tagManagerId: 'GTM-KQM9K52',
        trackingId: 'UA-113584393-1',
        mapsKey: 'AIzaSyD9mDk2SGtEJmu0kNyR_3Y1ioiexbn49ec',
        siteKey: '6Lc_1EAUAAAAACNWvhXwbWmjZdAgTKyn_LBFWeRq'
      },
    };
    break;
  case "staging":
    module.exports = {
      uri: 'http://api.liepaja.lv:3011/graphql',
      google: {
        tagManagerId: 'GTM-KQM9K52',
        trackingId: 'UA-113584393-1',
        mapsKey: 'AIzaSyD9mDk2SGtEJmu0kNyR_3Y1ioiexbn49ec',
        siteKey: '6Lc_1EAUAAAAACNWvhXwbWmjZdAgTKyn_LBFWeRq'
      },
    };
    break;  
  case "development":
    module.exports = {
      uri: 'http://api.liepaja.lv:3011/graphql',
      google: {
        tagManagerId: 'GTM-KQM9K52',
        trackingId: 'UA-113584393-1',
        mapsKey: 'AIzaSyD9mDk2SGtEJmu0kNyR_3Y1ioiexbn49ec',
        siteKey: '6Lc_1EAUAAAAACNWvhXwbWmjZdAgTKyn_LBFWeRq'
      },
    };
    break;
  default:
    module.exports = {
      uri: 'http://api.liepaja.lv:3011/graphql',
      google: {
        tagManagerId: 'GTM-KQM9K52',
        trackingId: 'UA-113584393-1',
        mapsKey: 'AIzaSyD9mDk2SGtEJmu0kNyR_3Y1ioiexbn49ec',
        siteKey: '6Lc_1EAUAAAAACNWvhXwbWmjZdAgTKyn_LBFWeRq'
      },
    };
    break;
}



// WEBPACK FOOTER //
// ./config.js